export const detectLoanRequestIntent = (text: string) => {
    const cleaned = text.toLowerCase().trim();

    /** ----------------------------------
     * DELETE: No name
     * ---------------------------------- */
    if (cleaned === "delete loan request" || cleaned === "remove loan request") {
        return { intent: "delete_loan_request" };
    }

    /** ----------------------------------
     * DELETE: With name
     * ---------------------------------- */
    const deleteMatch = cleaned.match(/delete (.+) loan request/);
    if (deleteMatch) {
        return { intent: "delete_loan_request", name: deleteMatch[1].trim() };
    }

    /** ----------------------------------
     * CREATE: Without name
     * ---------------------------------- */
    if (cleaned.includes("create loan request") || cleaned.includes("add loan request")) {
        return { intent: "create_loan_request" };
    }

    /** ----------------------------------
     * CREATE: With name
     * ---------------------------------- */
    const createMatch = cleaned.match(/create loan request named (.+)/);
    if (createMatch) {
        return { intent: "create_loan_request", name: createMatch[1].trim() };
    }

    return null;
};
